// extracted by mini-css-extract-plugin
module.exports = {"informationBox":"InformationBox_informationBox__uPr09","informationBox_title":"InformationBox_informationBox_title__zzODS"};